export default {
  root: {
    class: [
      // Sizing and Shape
      'min-w-[12rem]',
      'rounded-md',
      'shadow-md',

      // Spacing
      'py-2',

      // Colors
      'bg-secondary-0 dark:bg-secondary-700',
      'text-secondary-700 dark:text-white/80',
      'dark:border dark:border-secondary-700'
    ]
  },
  menu: {
    class: [
      // Spacings and Shape
      'list-none',
      'm-0',
      'p-0',
      'outline-none'
    ]
  },
  menuitem: {
    class: 'relative'
  },
  content: ({ context }) => ({
    class: [
      //Shape
      'rounded-none',
      // Colors
      'text-secondary-700 dark:text-white/80',
      {
        'text-secondary-500 dark:text-white/70': !context.focused && !context.active,
        'text-secondary-500 dark:text-white/70 bg-secondary-200 dark:bg-secondary-600/90':
          context.focused && !context.active,
        'text-primary-700 dark:text-secondary-0/80 bg-primary-50 dark:bg-primary-400/30':
          context.focused && context.active,
        'text-primary-700 dark:text-secondary-0/80 bg-primary-50 dark:bg-primary-400/30':
          !context.focused && context.active
      },

      // Transitions
      'transition-shadow',
      'duration-200',

      // States
      {
        'hover:bg-secondary-100 dark:hover:bg-secondary-600/80': !context.active,
        'hover:bg-primary-400/30 dark:hover:bg-primary-300/30 text-primary-700 dark:text-secondary-0/80': context.active
      }
    ]
  }),
  action: {
    class: [
      'relative',
      // Flexbox

      'flex',
      'items-center',

      // Spacing
      'py-3',
      'px-5',

      // Color
      'text-secondary-700 dark:text-white/80',

      // Misc
      'no-underline',
      'overflow-hidden',
      'cursor-pointer',
      'select-none'
    ]
  },
  icon: {
    class: [
      // Spacing
      'mr-2',

      // Color
      'text-secondary-600 dark:text-white/70'
    ]
  },
  label: {
    class: ['leading-none']
  },
  submenu: ({ props }) => ({
    class: [
      // Size
      'w-full sm:w-48',

      // Spacing
      'py-1',
      'm-0',
      'list-none',

      // Shape
      'shadow-md',
      'rounded-md',
      'dark:border dark:border-secondary-700',

      // Position
      'static sm:absolute',
      'z-10',
      { 'sm:absolute sm:left-full sm:top-0': props.level > 1 },

      // Color
      'bg-secondary-0 dark:bg-secondary-700'
    ]
  }),
  submenuicon: {
    class: ['ml-auto']
  },
  separator: {
    class: 'border-t border-secondary-200 dark:border-secondary-600 my-1'
  },
  transition: {
    enterFromClass: 'opacity-0',
    enterActiveClass: 'transition-opacity duration-250'
  }
};
